<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">Kullanım Şartları</h2>
        <button class="close-button" @click="closeModal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="privacy-content">

          <h3>Madde 1</h3>
          <h5>Taraflar</h5>
          <p>İşbu Kullanıcı Sözleşmesi (“Sözleşme”),Ibility Teknoloji A.Ş.(“Şirket”) ile Şirket tarafından işletilmekte olan <strong>ibilityapp</strong> ’a (“uygulama”) Uygulama’da yer alan admin panel ve kullanıcı lisans ürünlerini kullanmak adına <strong>“Kullanıcı”</strong> sıfatıyla kaydolan kişi arasında akdedilmektedir.</p>

          <h3>Madde 2</h3>
          <h5>Sözleşme’nin Konusu ve Kapsamı </h5>
          <ul>
            <li>2.1. Uygulama kapsamında Uygulama ve Ürünlerin kullanımına ilişkin olarak Uygulamada yayınlanarak kullanıcılara ilan edilen tüm kural ve şartlar da işbu Sözleşme’nin eki ve ayrılmaz bir parçası niteliğinde olup burada yer alan hak ve yükümlülüklerle birlikte tarafların tüm hak ve yükümlülüklerini oluşturur.</li>

            <li>2.2.İşbu Sözleşme, Şirket tarafından tüm fikri mülkiyet hakları kendisine ait olarak oluşturulan ve Kullanıcının satın almak kaydıyla faydalanabileceği Ibility App olarak sunulan Yapay Zeka Destekli
              Mikro Öğrenme Platformu ile... satışa sunduğu/sunacağı diğer Ürünlerden ve kullanıcılara sunduğu Ürünlerden yararlanılmasına ilişkin koşul ve şartlar ile ilgili tarafların hak ve yükümlülüklerinin belirlenmesi amacıyla akdedilmektedir. Ibility platformunun sunduğu hizmet ve içerikler TEKLİF FORMU’nda detaylandırılmış olup, işbu teklif formu sözleşmenin eki niteliğindedir.</li>

            <li>2.3. Sözleşme, Kullanıcı tarafından sözleşmenin elektronik ortamda kabulü ile birlikte yürürlüğe girecek olup; sözleşmeye uygun olarak taraflarca sona erdirilmediği veya haklı nedenle sözleşmenin feshedilebileceği bir durum oluşmadığı sürece aynı şartlar altında yenilenecektir.</li>

          </ul>

          <h3>Madde 3</h3>
          <h5>Tarafların Hak ve Yükümlülükleri</h5>
          <ul>
            <li>3.1. Ibility App hizmetlerinden faydalanmak adına Kullanıcı sıfatını kazanabilmek için Şirket tarafından talep edilen bilgilerin eksiksiz, güncel ve gerçeğe uygun olarak Kullanıcı tarafından sağlanması ve işbu Sözleşmenin yine Kullanıcı tarafından onaylanması gerekir. Kullanıcı, sözleşmeyi onaylarken verdiği bilgilerde bir değişiklik olması durumunda güncel bilgileri azami 15 gün içinde Şirket’e bildirmek zorundadır. Verilen bilgilerin eksik olması veya doğru olmaması yahut güncelliğini kaybetmiş olması nedeniyle Uygulama ya da Ürünlere erişim sağlanamaması ve/veya Uygulama ya da Ürünlerden faydalanılamaması durumunda Şirketin herhangi bir sorumluluğu doğmaz.</li>

            <li>3.2.Kullanıcı, işbu Sözleşmeyi akdetmeye engel yasal bir engelinin bulunmadığını (gerçek kişiler yasal ehliyeti haiz olduğunu ve tüzel kişi temsilcisi de yetkili temsilci bulunduğunu) kabul ve beyan eder.</li>

            <li>3.3. Şirket tarafından her bir Kullanıcıya tek bir Kullanıcı hesabı açılır. Her bir kullanıcı hesabı, yalnızca tanımlandığı kişi tarafından kullanılabilir ve şahsi olarak tahsis edilmiştir. Kullanıcı adı ve şifrenin herhangi bir üçüncü kişiyle paylaşılması, devredilmesi veya ortak kullanım amacıyla başka kişiler tarafından erişime açılması kesinlikle yasaktır. Şirket, bir kullanıcı hesabının birden fazla kişi tarafından kullanıldığını, IP adresleri, erişim zamanları, cihaz kimlikleri gibi teknik yollarla tespit etmesi halinde, her bir tespit için ayrıca kullanıcıya bildirime gerek olmaksızın, lisans başına düşen kullanım bedelinin 3 (üç) katı tutarında ceza faturasını düzenleme ve tahsil etme hakkına sahiptir.
              Bu tür çoklu ve yetkisiz kullanımın tespit edilmesi halinde, Şirket ayrıca tek taraflı olarak sözleşmeyi feshedebilir ve Kullanıcı'nın sisteme erişimini derhal durdurabilir. Bu durumda Kullanıcı, kalan abonelik süresi boyunca olan tüm ücretleri tam ve peşin ödemekle yükümlüdür. Herhangi bir iade talebi kabul edilmez.</li>

            <li>3.4. Ürünlere erişim, kullanıcı adı ve şifrenin uygulama üzerinde girilmesiyle mümkün olur. Başka bir kullanıcı adı belirlenmediği takdirde, kullanıcı adı, tanımlanan e-posta adresine bağlı oluşturulan kullanıcı adıdır. Kullanıcı adı ve şifresi, kullanıcı hesabının tanımlı olduğu kişi veya bir tüzel kişilik ise ürünü kullanmak üzere yetkilendirdiği kişinin kullanımı içindir. Kullanıcı adı ve şifresinin üçüncü kişilere kullandırtılması durumunda, Şirket, her bir üçüncü kişi kullanımı için satın alınan ürünün ücreti tutarında fatura düzenleyerek kullanıcıdan bu bedeli tahsil etmek hakkını haizdir. Bunun yanında, kullanıcı adı ve şifre güvenliği ile gizliliğinin korunmasından Şirket sorumlu değildir. Uygulama üzerinde, bu kullanıcı adı ve şifrenin kullanımı sonrasında veya bununla ilgili gerçekleştirilen her türlü işlem ve faaliyetin Kullanıcı tarafından gerçekleştirildiği kabul olunur. Bu faaliyetler nedeniyle doğabilecek hukuki veya cezai bir sorumluluk Kullanıcıya aittir.</li>

            <li>3.5. Kullanıcı, Ürünleri, ürünlerin oluşturulma amacına uygun ve hukuka uygun amaçlarla kullanmak ve kullanıma ilişkin Uygulamada yer verilen ilanları takip etmek zorundadır.</li>

            <li>3.6. Kullanıcı, muhtelif zamanlarda ürünleri kullanması için üçüncü bir kişiyi veya bir çalışanını yetkilendirebilir. Kullanıcı, bu kişinin de işbu sözleşmeye ve Uygulamada ilan edilen talimatlara uygun olarak kullanım kılavuzuna uygun kullanmasından sorumludur.</li>

            <li>3.7. Kullanıcı, Uygulama ve Ürünleri, kopyalamayacağını, uyarlamayacağını, çoğaltmayacağını, çıktı almak suretiyle yazılı bir materyal haline getirip dağıtmayacağını, kullanım kılavuzu çerçeve dışında kullanmayacağını, Ürünlerin ve yazılımları ile tersine mühendislik işlemleri yapmayacağını; kabul, beyan ve taahhüt eder.</li>

            <li>3.8. Şirket, Ürün ve hizmetlerin kesintisiz bir şekilde sunulması için gerekli tüm teknik altyapıyı sağlamak adına azami özeni gösterir. Ancak zaman zaman bakım, güncelleme veya sistem iyileştirmeleri gibi sebeplerle hizmete geçici olarak erişilemeyebilir. Ayrıca Şirketin kontrolü dışında gelişen teknik aksaklıklar da hizmete erişimi sınırlayabilir. Bu gibi durumlarda Şirket,  ZenDesk programı üzerinden durumun aciliyet seviyesine göre verilen hedef sürelerde duruma müdahale etmeyi taahhüt eder.</li>

            <li>3.9. Şirket, kullanıcıların içerik güvenliği ve sürekliliğini sağlamak amacıyla elindeki teknik imkanlar çerçevesinde gerekli önlemleri almaya çalışır. Ancak bazı durumlarda içerik kayıpları yaşanabilir. Kullanıcıların önemli içeriklerini ayrıca yedeklemesi önerilir. Şirket, bu tür teknik riskleri en aza indirmek için düzenli bakım ve kontrol süreçleri uygulamaktadır.</li>

            <li>3.10. Şirket ile Kullanıcı arasında gizliliğe ve kişisel verilerin korunmasına ilişkin hükümler, işbu Sözleşmeye ek niteliğinde olup, Uygulamada yayımlanmıştır. Taraflar bu hükümlere riayet etmeyi kabul ve taahhüt ederler.</li>

            <li>3.11. Şirket, teknik destek sunmak veya Ürünlerden azami faydanın sağlanılması adına, Kullanıcı ile iletişime geçmek adına, çeşitli iletişim araçlarına Uygulamada yer verebilir. Bu iletişim araçlarının hukuka uygun kullanılması gerekmekte olup, aksi durum Kullanıcının sorumluluğunu doğurur. Şirketin, bu araçlar ve kullanımı nedeniyle herhangi bir sorumluluğu olmamasının yanı sıra, Şirket, Uygulama üzerinden sağladığı iletişim araçlarını dilediği zaman kaldırma veya değiştirme hakkına da sahiptir.</li>

            <li>3.12. Şirket, işbu sözleşme ve/veya eklerini Kullanıcının rızasına gerek olmaksızın tek taraflı değiştirebilir. Değişiklik, değişikliğin ve yeni metnin Uygulama’da yayımlanmasıyla yürürlüğe girer ve tarafları bağlar.</li>

            <li>3.13. Kullanıcının, işbu sözleşme ve eklerine aykırı davranışı veya hukuka aykırı eylemlerde bulunması durumunda, Şirket, Kullanıcının üyeliğini askıya alabileceği gibi sözleşmeyi de feshedebilir. Şirket tarafından kullanıcı desteğinin nasıl kullanacağı açıkça kılavuzda yer aldığı şekilde olacaktır. Böyle bir durumda Şirketin söz konusu aykırılıktan doğan zararlarının Kullanıcıdan talep etme hakkı saklıdır.</li>

            <li>3.14. Kullanıcı, Uygulama kapsamında içerik oluşturma, düzenleme veya yükleme imkanına sahip olduğu ürün ve hizmetleri kullanırken, yürürlükteki mevzuata, genel ahlak ve kamu düzenine uygun hareket etmeyi; nefret söylemi, ayrımcılık, şiddet içerikleri, yasa dışı kullanım, yanıltıcı bilgi üretimi, cinsiyetçilik, ırkçılık ve benzeri etik dışı içerikler oluşturmamayı kabul, beyan ve taahhüt eder. Şirket, Uygulama üzerinden kullanıcı tarafından oluşturulan içerikleri denetleme ve izleme hakkını saklı tutar. Şirket, söz konusu içeriklerin mevzuata, kamu düzenine, genel ahlak kurallarına veya işbu sözleşmeye aykırı olduğunu tespit etmesi halinde, herhangi bir bildirimde bulunmaksızın bu içerikleri yayından kaldırabilir, silebilir, erişimi kısıtlayabilir ve/veya kullanıcı hesabını askıya alabilir ya da tamamen sona erdirebilir. Bu durumda Kullanıcının üyeliği sona erdirilse dahi, Kullanıcı, kalan süreye ilişkin tüm ücretleri ödemeyi kabul eder; herhangi bir iade yapılmaz.

              Ayrıca, bu tür etik dışı içerik nedeniyle üçüncü kişiler tarafından Şirkete yöneltilebilecek her türlü talep, tazminat, idari yaptırım ve benzeri zararlar dolayısıyla Şirketin uğrayabileceği doğrudan ve dolaylı tüm zararlardan Kullanıcı bizzat sorumlu olduğunu ve derhal tazmin edeceğini kabul, beyan ve taahhüt eder.</li>

            <li>3.15. Kullanıcı, Şirket ile kurduğu sözleşme ilişkisi kapsamında, Şirketin kullanıcı deneyimini, başarı hikâyelerini ve kullanıcıya ait kurumsal logoyu yalnızca tanıtım ve referans amaçlı olarak web sitesi, tanıtım dökümanları ve sunumlarında kullanmasına ön onay verdiğini kabul eder. Bununla birlikte, Şirket tarafından bu kullanım için her durumda ayrıca yazılı bir açık rıza/onay belgesi alınacaktır.</li>

          </ul>

          <h3>Madde 4</h3>
          <h5>Ödeme Koşulları</h5>

          <ul>
            <li>4.1. Ödeme koşulları, işbu sözleşmeye Ek-1 olarak eklenen teklif formunda yazan şekilde geçerli olur. Şirket tarafından müşterinin tüzel kişi olması durumunda her aybaşında fatura kesilecek ve kesim tarihinde bildirilen ödeme yöntemleriyle, fatura tarihinden itibaren 30 (otuz) gün içinde ödemeyi kabul ve taahhüt eder. Müşterinin bireysel olduğu hallerde ödeme web sitesinde yer alan ödeme yöntemlerinden herhangi biri aracılığıyla abonelik ilişkisi kurulduğu anda gerçekleştirilir.</li>

            <li>4.2. Ürünlerin kullanımına ilişkin ücretler, ödeme koşulları, ücretlerin yürürlük tarihleri bilgilendirme teklif E-maillerinde ilan edildiği gibidir. Şirket, Kullanıcı tarafından ödemenin yapılmasını müteakip Kullanıcının kayıtlı iletişim adresine kullanım ücretlerine ilişkin faturayı gönderecektir. İlgili ücretlere ilişkin vergi ve harçların ödenmesinden Kullanıcı sorumlu olacaktır.</li>

            <li>4.3. Kullanıcının üyelik süresi boyunca üyelik paketine ilişkin ücret ve ödeme koşullarında yapılacak değişiklikler, Kullanıcının üyelik döneminin sona ermesine dek uygulanmayacak, yeni ücretler ve ödeme koşulları yeni üyelik döneminin başlamasıyla geçerli olacaktır. Üyelik dönemi boyunca Sözleşmenin feshi de dâhil olmak üzere üyeliğin herhangi bir nedenle sona ermesi halinde geri ödeme yapılmayacaktır.</li>

            <li>4.4. Kullanıcı, üyeliğini sona erdirmek istediğini her zaman bildirebilir. Bu durumda kullanıcı sözleşmeyi yenileme talebini 30 gün kalaya kadar bildirmezse yenileme indiriminden faydalanamayacaktır.</li>

            <li>4.5. Kullanıcı, Ücretsiz İçerik ve Ürenleri Uygulama’da Şirketin belirleyeceği süre boyunca ücret ödemeden kullanabilecektir. Söz konusu ücretsiz dönemin/deneme periyodunun bitimiyle Kullanıcı’nın Uygulama’ya üyeliği sona ermemekte olup, kullanıcı kendisine uygun olan Ürünü seçerek Uygulamada açıklanan kullanım ücretlerinin yine Uygulamada beyan edilen ödeme koşulları ve araçları ile tam ve eksiksiz olarak ödenmesi ile kullanmaya başlar.</li>

            <li>4.6. Şirketin ücretli ve ücretsiz ürünlerin türü, hizmet seviyesi, işlevselliği, kampanyaları ya da sözleşme süresine/türüne göre belirlenecek ücretleri hakkında her türlü değişikliğe gitme hakkına sahiptir.</li>

            <li>4.7. Kullanıcı, hizmeti yıllık abonelik modeli ile satın almayı tercih edebilir. Tercih edilen abonelik tipi, Kullanıcı ile Şirket arasında imzalanan Teklif Formu'nda belirtilir ve bu Sözleşme’ye ek teşkil eder. Abonelik süresi sonunda, Kullanıcı tarafından sona erdirilmediği sürece abonelik, aynı koşullarla otomatik olarak yenilenir. Yenileme öncesinde Kullanıcıya en az 15 gün önce bilgilendirme yapılır. Kullanıcı abonelik yenilemesini istemiyorsa, abonelik süresinin bitimine en az 15 gün kala Şirket’e yazılı bildirimde bulunmalıdır. Aksi halde abonelik otomatik olarak yenilenir ve yeni dönem ücreti tahsil edilir. Yıllık aboneliklerde erken fesih talebi olması halinde, kalan süreye ilişkin ücret iadesi yapılmaz. Ancak Şirket, hizmetin verilmediği dönem için istisnai durumlarda iade değerlendirmesi yapabilir. Yıllık aboneliklerde erken fesih talebi olması halinde, kalan süreye ilişkin ücret iadesi yapılmaz. Ürün kurulumu tamamlanıp sözleşme imzalandıktan sonra yıllık abonelik bedeli peşin olarak tahsil edilir ve iade edilmez. Kullanıcı, aboneliğin süresinden önce iptalini talep etse dahi ürün, belirlenen abonelik süresi boyunca aktif kalır ve bu sürenin sonunda iptal edilir.</li>

            <li>4.8. Şirket, Kullanıcılara Uygulama’yı değerlendirmeleri amacıyla yalnızca bir defaya mahsus olmak üzere 7 (yedi) günlük ücretsiz bir deneme süresi (“Deneme Süresi”) sunabilir. Bu süre boyunca Kullanıcıdan herhangi bir ücret tahsil edilmez. Deneme Süresi, Kullanıcının e-posta adresi ve cihaz bilgilerine bağlı olarak bir kez tanımlanır. Kullanıcı, Deneme Süresi boyunca dilediği anda üyeliğini iptal edebilir. Ancak, Kullanıcı Deneme Süresi sonunda üyeliğini iptal etmezse, üyeliği otomatik olarak Şirketin belirlediği standart ücretli abonelik planına geçer ve bu kapsamda ödeme yükümlülüğü başlar. Deneme Süresi sonunda başlayan ücretli abonelik süresi, Uygulamada ilan edilen güncel paket ve fiyat koşullarına göre yürürlüğe girer. Ücretli üyelik başladıktan sonra ilgili kullanım bedeli iade edilmez.</li>

            <li>4.9. Deneme Süresi yalnızca Şirketin belirlediği ürün ve hizmetler için geçerlidir. Şirket, bu süre zarfında sunulan içerikleri kısıtlama, değiştirme veya uygulamayı durdurma hakkını saklı tutar.</li>
          </ul>

          <h3>Madde 5 </h3>
          <h5>Fikri Mülkiyet Hakları</h5>
          <ul>
            <li>5.1. Şirket, Uygulama ve Ürünler üzerindeki her türlü hak ve menfaatin sahibidir. İşbu Sözleşme kapsamında Kullanıcıya Uygulama ve Ürünleri sadece kullanmak ve faydalanmak üzere kişiye özel, telifsiz, devredilemez ve münhasır olmayan bir kullanım izni verilmektedir. Sözleşme ve eklerindeki hiçbir hüküm Uygulama ve Ürünlere ilişkin hakların ve menfaatlerin kısmen dahi olsa Kullanıcıya devredildiği şeklinde yorumlanamaz. Kullanıcı, işbu Sözleşme kapsamında Şirkete, Kullanıcının satın aldığı Ürün/Ürünlere erişimi, kullanması ve hizmetlerin sağlanmasına yönelik diğer amaçlarla, kendisine ait bilgilerinin ve içeriğin kullanılması, kopyalanması, iletilmesi, saklanması ve yedeğinin alınması için kullanım hakkı tanımaktadır. Şirket, hizmetlerin sağlanması amacıyla içeriğe ilişkin olarak üçüncü kişi geliştiricilere alt lisans verme hakkına haizdir.</li>

            <li>5.2. Kullanıcı, hiçbir şekilde ve nedenle Uygulamayı veya Ürünleri kopyalama, değiştirme, çoğaltma, ters mühendisliğe tabi tutma, geri derleme ve sair şekillerde Uygulama üzerindeki yazılımın kaynak koduna ulaşma, Uygulamadan işleme eser oluşturma hakkına sahip değildir. Uygulamaya ilişkin tarayıcı ve içeriklerin herhangi bir şekilde değiştirilmesi, Şirket’in açık izni olmaksızın Uygulamaya veya Uygulamadan link verilmesi kesinlikle yasaktır.</li>

            <li>5.3. Kullanıcı, herhangi bir şekilde Şirket’in (veya bağlı şirketlerinin) ticari unvanını, markasını, logosunu, alan adını, şablonunu kullanamayacağı gibi, Şirket ve hizmetleriyle bağlantılı veya benzer görünebilecek hiçbir eylemde de bulunamaz.</li>
          </ul>

          <h3>Madde 6</h3>
          <h5>Sorumluluğun Sınırlandırılması</h5>

          <ul>
            <li>6.1. ürünler içinde,
              <ol>
                <li>bility App, yürürlükte bulunan 6698 sayılı Kişisel Verileri Koruma Kanunu ve ilgili alt mevzuatını esas alarak hazırlanmış olup, 6698 sayılı Kişisel Verileri Koruma Kanunu kapsamında olmayan iş/hizmet ilişkileri bakımından bir rehber olma amacı taşımamaktadır.</li>
                <li>‘Eğitim’ adı altında sunulan ürün ise yürürlükte bulunan 6698 Sayılı Kişisel Verilerin Korunması Kanunu ve ilgili alt mevzuatı esas alınarak hazırlanmıştır. Şirket, bu ürününün Kişisel Verilerini Koruma Uyum işlemleri ve genel anlamda ‘Veri Sorumlusu’ uyum işlemleri alanıyla ilgili bir rehber olarak kullanılmasını tavsiye etmektedir.</li>
                <li>Kullanıcı, Şirket tarafından sunulan hizmetlerin ifası kapsamında işlenecek kişisel verilerine ilişkin olarak, Ek-2’de yer alan Aydınlatma Metni ve varsa ayrı olarak imzalanan Veri İşleme Sözleşmesi hükümlerini okuduğunu, anladığını ve bu kapsamda kişisel verilerinin işlenmesine rıza gösterdiğini kabul ve beyan eder.</li>
              </ol>
            </li>

            <li>6.2. Uygulama kapsamındaki Ibility App ve sair içerikler, hazırlayanların bilgi ürünü olup, sübjektif nitelikte ve olduğu gibi sunulmaktadır.</li>

            <li>6.3. Şirket, Ürünler’in kullanımının kesintisiz ve hatasız olacağını taahhüt etmemektedir. Şirket, her ne kadar Ürünlerin yedi gün ve yirmi dört saat kullanılabilir olmasını hedeflemekte ise de Ürünlere ve Uygulamaya erişimi sağlayan sistemlerin doğru ve efektif çalışacağına ve daima Kullanıcı tarafından erişilebilir olacağına dair bir garanti vermemektedir. Ancak şirket, kesinti veya hata durumlarında ivedilikle destek vermeyi ve düzeltmeyi taahhüt eder.</li>

            <li>6.4. Şirket tarafından Uygulama üzerinden başka internet uygulamalarına veya kaynaklara link verilebilir. Bu durum, hiçbir şekilde, bu tür linklerin yöneldiği internet uygulamasını veya işleten kişisini veya kaynakları desteklemek amacı taşımayacağı gibi internet uygulaması, kaynaklar veya içerdiği bilgilere yönelik herhangi bir türde bir beyan veya garanti verildiği anlamına da gelmez. Söz konusu linkler vasıtasıyla erişilen portallar, internet uygulamaları, kaynaklar dosyalar ve içerikler, hizmetler veya ürünler vb. veya bunların içeriği hakkında Şirket’in herhangi bir sorumluluğu bulunmamaktadır.</li>

            <li>6.5. Kullanıcı, uygulama ve ürünlerin kullanımından münhasıran sorumludur. Kullanıcı, fikri mülkiyet ihlalleri, içerik, Ürünler ve Uygulamanın kullanımına ilişkin olarak üçüncü kişiler tarafından iletilebilecek her türlü iddia ve talepten (yargılama masrafları ve avukatlık ücretleri de dahil olmak üzere) şirketi sorumsuz kabul ettiğini; Şirketin bu nedenle üçüncü kişilere ödemek durumunda kalabileceği herhangi bir tazminatı derhal ve nakden Şirkete ödeyeceğini kabul, beyan ve taahhüt eder.</li>

            <li>6.6. Şirket, uygulanacak hukukun izin verdiği ölçüde, kar kaybı, şerefiye ve itibar kaybı, ikame ürün ve hizmet temini için yapılan harcama gibi kalemler de dâhil ancak bunlarla sınırlı olmaksızın Uygulamanın kullanımı neticesinde meydana gelen hiçbir doğrudan, dolaylı, özel, arızi, cezai zarardan sorumlu olmayacaktır. Buna ek olarak Şirket, zımni garanti, ticarete elverişlilik, belli bir amaca uygunluk da dâhil ancak bunlarla sınırlı olmamak üzere, açık veya zımni hiçbir türlü garanti vermediğini de ayrıca beyan eder. Şirketin işbu sözleşme kapsamındaki sorumluluğu her halükârda ilgili zararın doğduğu tarihe kadar kullanıcı tarafından işbu sözleşmeye konu hizmetler kapsamında Şirkete ödediği tutarla sınırlı olacaktır. Bu tutarı aşan zararlar bakımından Kullanıcı Şirkete bir talep yöneltemez. Bu tutarı aşan zararlar bakımından Kullanıcı, haklarından feragat etmektedir.</li>

          </ul>

          <h3>Madde 7</h3>
          <h5>Sözleşme’nin Yürürlüğü ve Feshi</h5>
          <ul>
            <li>7.1. İşbu Sözleşme, sözleşmenin elektronik ortamda Kullanıcı tarafından kabul edilmesiyle birlikte yürürlüğe girecek ve taraflardan herhangi biri tarafından aşağıda belirtilen şekilde feshedilmediği sürece yürürlükte kalacaktır.</li>

            <li>7.2. Taraflardan herhangi biri, diğer tarafça bildirilen elektronik posta adresine yapacağı yazılı bir bildirimle işbu Sözleşmeyi dilediği zaman ve herhangi bir gerekçe göstermeksizin ve tazminat ödemeksizin feshedebilecektir. Bununla birlikte, Şirket, Kullanıcının üyelik süresinin dolmaması durumunda, kalan süre kadar ücreti iadesi yapmayacaktır.</li>

            <li>7.3. Taraflardan birinin işbu Sözleşmeden kaynaklanan yükümlülüklerini tam ve gereği gibi yerine getirmemesi veya hukuka aykırı hareket etmesi halinde, diğer tarafça yapılacak yazılı bildirime karşın söz konusu ihlal veya aykırılık azami 15 gün içerisinde giderilmez ise, Sözleşme, bildirimi yapan tarafça feshedilebilecektir. Bahsi geçen ihlal veya aykırılığın Kullanıcı tarafından gerçekleştirilmesi halinde Şirket ihlal veya aykırılık giderilene kadar Kullanıcı statüsünü askıya alma hakkına sahip olacaktır.</li>

            <li>7.4. Sözleşmenin feshi Tarafların fesih tarihine kadar doğmuş olan hak ve yükümlülüklerini ortadan kaldırmaz.</li>
          </ul>

          <h3>Madde 8</h3>
          <h5>Muhtelif Hükümler</h5>
          <ul>
            <li>8.1. İşbu Sözleşme ekleri ile bir bütündür. İşbu Sözleşme’nin herhangi bir hükmünün veya sözleşmede yer alan herhangi bir ifadenin geçersizliği, yasaya aykırılığı ve uygulanamazlığı, Sözleşme’nin diğer hükümlerinin yürürlüğünü ve geçerliliğini etkilemeyecektir.</li>
            <li>8.2. Kullanıcı ile Şirket arasındaki iletişim Kullanıcı tarafından kayıt olurken bildirilen e-mail adresi vasıtasıyla veya Uygulamada yer alan genel bilgilendirme aracılığıyla yapılır. E-mail ile yapılan iletişim yazılı iletişimin yerini tutar. E-mail adresini güncel tutmak ve Uygulamayı bilgilendirmeler için düzenli kontrol etmek Kullanıcının sorumluluğundadır. Taraflar arasında yapılan tüm e-posta yazışmaları veya diğer iletişim araçlarıyla yapılan yazışmalar, yazılı delil niteliğindedir.</li>
            <li>8.3. İşbu Sözleşme ve eklerinden kaynaklı uyuşmazlıklarda İstanbul Anadolu Mahkemeleri ve İcra Daireleri yetkilidir.</li>
          </ul>

          <h3>İletişim</h3>
          <p>Kullanım şartlarımızla ilgili herhangi bir sorunuz veya endişeniz varsa, lütfen bizimle iletişime geçmekten çekinmeyin.</p>

          <div class="notice">
            <p><strong>NOT:</strong> Bu kullanım şartları, değişen yasal gereksinimlere, teknolojik gelişmelere ve işletme ihtiyaçlarına bağlı olarak zaman zaman güncellenebilir. Yapılan değişiklikler web sitemizde yayınlanacaktır.</p>
          </div>

          <p class="last-updated">Son güncellenme: 27.08.2025</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUseModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0;
}

.modal-title {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 24px;
  color: #111827;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(85vh - 100px);
}

.privacy-content {
  line-height: 1.6;
}

.intro-section {
  background-color: #f8fafc;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  border-left: 4px solid #4A68F8;
}

.intro-section p {
  margin: 0 0 12px 0;
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #374151;
}

.intro-section p:last-child {
  margin-bottom: 0;
}

.privacy-content h3 {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 18px;
  color: #111827;
  margin: 32px 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.privacy-content h3:first-of-type {
  margin-top: 0;
}

.privacy-content p {
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 16px;
  text-align: justify;
}

.privacy-content ul {
  margin: 16px 0;
  padding-left: 24px;
}

.privacy-content li {
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 8px;
  line-height: 1.5;
}

.important-note {
  background-color: #fef3cd;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.important-note p {
  margin: 0;
  color: #92400e;
  font-size: 14px;
}

.contact-info {
  background-color: #eff6ff;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.contact-info p {
  margin: 0;
  color: #1e40af;
  font-size: 14px;
}

.company-info {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
}

.company-info p {
  margin: 8px 0;
  font-size: 14px;
  color: #374151;
}

.company-info p:first-child {
  margin-top: 0;
}

.company-info p:last-child {
  margin-bottom: 0;
}

.notice {
  background-color: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.notice p {
  margin: 0;
  color: #0c4a6e;
  font-size: 13px;
  font-style: italic;
}

.last-updated {
  font-size: 12px !important;
  color: #9ca3af !important;
  font-style: italic;
  margin-top: 32px !important;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  text-align: center !important;
  font-weight: 500;
}

@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-content {
    max-height: 90vh;
    max-width: 95%;
  }

  .modal-header {
    padding: 16px 16px 0 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-title {
    font-size: 20px;
  }

  .privacy-content h3 {
    font-size: 16px;
  }

  .intro-section {
    padding: 16px;
  }

  .privacy-content ul {
    padding-left: 20px;
  }
}

@media (max-width: 480px) {
  .modal-content {
    max-width: 100%;
    margin: 10px;
  }

  .privacy-content h3 {
    font-size: 15px;
  }

  .privacy-content p,
  .privacy-content li {
    font-size: 13px;
  }

  .intro-section {
    padding: 12px;
  }

  .important-note,
  .contact-info,
  .company-info,
  .notice {
    padding: 12px;
  }
}
</style>
